import "./store/immerSetup";
import "./setupAxiosCrypto";
import "./setupAxiosInterceptors";
import React from "react";
import { createRoot } from "react-dom/client";
import { initGlobalErrorLogging } from "utils/errorLog";
import { ErrorLogBoundary } from "components/ErrorLogBoundary";
import "assets/plugins/nucleo/css/nucleo.css";
import "assets/scss/argon-dashboard-react.scss";
import App from "App";
import { store } from "store";
import { Provider } from "react-redux";
import Toast from "components/ToastNotification";
import NotificationApp from "components/NotificationModal/Notification";

initGlobalErrorLogging();

window.process = {};
const isAppleDevice = /iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent);
const root = createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <React.StrictMode>
      <ErrorLogBoundary>
        <Toast />
        <App />
      </ErrorLogBoundary>
    </React.StrictMode>
    {!isAppleDevice && <NotificationApp />}
  </Provider>
);
